var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_1790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.20368 23.466H15.832C16.3058 23.466 16.6892 23.0826 16.6892 22.6088C16.6892 22.135 16.3058 21.7517 15.832 21.7517H4.20368C2.83092 21.7517 1.71429 20.635 1.71429 19.2623V13.5353L7.1861 9.72321L16.8365 18.5073C17.0006 18.6571 17.2073 18.7307 17.4132 18.7307C17.6459 18.7307 17.8778 18.6362 18.0469 18.4503C18.3658 18.1004 18.3407 17.558 17.99 17.24L7.83398 7.99554C7.53767 7.72517 7.09403 7.69754 6.76758 7.92606L1.71429 11.4467V4.20368C1.71429 2.83092 2.83092 1.71429 4.20368 1.71429H19.2623C20.635 1.71429 21.7517 2.83092 21.7517 4.20368V15.832C21.7517 16.3058 22.135 16.6892 22.6088 16.6892C23.0826 16.6892 23.466 16.3058 23.466 15.832V4.20368C23.466 1.88588 21.5801 0 19.2623 0H4.20368C1.88588 0 0 1.88588 0 4.20368V19.2623C0 21.5801 1.88588 23.466 4.20368 23.466Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2145 3.88477C14.3579 3.88477 12.8479 5.39565 12.8479 7.25223C12.8479 9.10882 14.3579 10.6189 16.2145 10.6189C18.0711 10.6189 19.5812 9.10882 19.5812 7.25223C19.5812 5.39565 18.0711 3.88477 16.2145 3.88477ZM16.2145 8.90458C15.3038 8.90458 14.5622 8.16295 14.5622 7.25223C14.5622 6.34068 15.3038 5.59905 16.2145 5.59905C17.1252 5.59905 17.8669 6.34068 17.8669 7.25223C17.8669 8.16295 17.1252 8.90458 16.2145 8.90458Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 20.0784H21.7927V18.7282C21.7927 18.2545 21.4093 17.8711 20.9355 17.8711C20.4618 17.8711 20.0784 18.2545 20.0784 18.7282V20.0784H18.7282C18.2545 20.0784 17.8711 20.4618 17.8711 20.9355C17.8711 21.4093 18.2545 21.7927 18.7282 21.7927H20.0784V23.1429C20.0784 23.6166 20.4618 24 20.9355 24C21.4093 24 21.7927 23.6166 21.7927 23.1429V21.7927H23.1429C23.6166 21.7927 24 21.4093 24 20.9355C24 20.4618 23.6166 20.0784 23.1429 20.0784Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_1790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.132ee165bd0eb356d5d755c81128ed49.svg";
export { ForwardRef as ReactComponent };